export class CodedError extends Error {
    code;
    constructor(message, code) {
        super(message);
        this.code = code;
    }
}
//# sourceMappingURL=CodedError.js.map